module.exports = __webpack_public_path__ + "static/media/shop.4ecd13b3.svg";